import React, { FC } from 'react';
import useQueryParams from "../../utils/hooks/useQueryParams";
import { Span } from "../Text/Text";
import Icon from "../Icon/Icon";
import { IconColorE } from "../../models/enums";
import { clss } from "../../utils/helpers/styleHelpers";
import { statusFilters } from '../../utils/helpers/statusFilters';

import styles from './statusTag.module.scss';

type StatusTagPropTypes = {
    status?: string;
    isRemovable?: boolean;
}

/**
 * Gets status state from query param and shows it
 * */

const StatusTag: FC<StatusTagPropTypes> = ({ status: statusProp, isRemovable = true }) => {
    const { searchParams, removeQueryParam } = useQueryParams();

    // define status from outer prop or from query param
    const status = statusProp || searchParams.get('status');
    const statusFilter = !!status && statusFilters.find(({ value }) => value === status);

    const removeStatus = () => {
        removeQueryParam('status');
    };

    return statusFilter ? (
        <div className={styles.wrapper}>
            <Span
                style={{ backgroundColor: statusFilter.color }}
                className={clss([styles.tag, isRemovable ? styles.tagSpace : ''])}
            >
                {statusFilter.label}
            </Span>
            {isRemovable && (
                <Icon
                    name='close'
                    title='Remove status filter'
                    className={styles.closeIcon}
                    color={IconColorE.GRAY}
                    onClick={removeStatus}
                />
            )}
        </div>
    ) : null;
};

export default StatusTag;